import { QueryClient } from '@tanstack/react-query';

import { ApiClientError } from '@terra/api-client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (n, e) => (e instanceof ApiClientError && !e.isRetryable ? false : n < 2),
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
});
